import { useLingui } from "@lingui/react/macro";
import { classNames } from "@offstreetparking/design-system/utils";
import { forwardRef } from "react";
export type MobileNavButtonProps = {
	isVisible: boolean;
	onClick: () => void;
};
export const MobileNavButton = forwardRef<HTMLButtonElement, MobileNavButtonProps>(({ isVisible, onClick }, ref) => {
	const { t } = useLingui();
	return (
		<button
			ref={ref}
			type="button"
			className="flex h-8 w-8 cursor-pointer items-center justify-center"
			aria-label={t`Open Navigation`}
			aria-expanded={isVisible}
			aria-controls="mobile-nav-menu"
			onClick={onClick}
		>
			<div className="space-y-1.5">
				<div
					className={classNames(
						"h-0.5 w-6 rounded-md bg-black transition-transform duration-300",
						isVisible ? "translate-y-1.5 rotate-45" : "",
					)}
				/>
				<div
					className={classNames(
						"h-0.5 w-6 rounded-md bg-black transition-all duration-300",
						isVisible ? "opacity-0" : "",
					)}
				/>
				<div
					className={classNames(
						"h-0.5 w-6 rounded-md bg-black transition-transform duration-300",
						isVisible ? "-rotate-45 -translate-y-2.5" : "",
					)}
				/>
			</div>
		</button>
	);
});
MobileNavButton.displayName = "MobileNavButton";
